import Splide from "@splidejs/splide";

const initPromoSlider = (root) => {
  const splideElement = root.querySelector("[data-promo-splide]");
  if (!splideElement) {
    return;
  }

  const slides = splideElement.querySelectorAll(".splide__slide");
  if (slides.length > 1) {
    new Splide(splideElement, {
      type: "loop",
      perPage: 1,
      perMove: 1,
      gap: 0,
      arrows: true,
      pagination: true,
      autoplay: true,
      interval: 4000,
      pauseOnHover: true,
      pauseOnFocus: false,
      speed: 600,
      drag: true,
    }).mount();
  } else {
    splideElement.classList.add("splide--single");
  }
};

const init = () => {
  document.querySelectorAll(".promo-slider").forEach(initPromoSlider);
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}

export default init;
